import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import CategoryTableFilters from "components/subComponents/CategoryTableFilters";

import useCategoryList from "hooks/list/useCategoryList";

function ElencoCategorie() {
    const categoryListHook = useCategoryList();

    const { navigateToNewCategory, dataTableHook, alertConfirmHook } = categoryListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <CategoryTableFilters categoryListHook={categoryListHook} />

                <DataTableSimple dataTableHook={dataTableHook} />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewCategory}>
                        Nuova Categoria
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoCategorie;
